(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["af-premium-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-afph-root]');
    roots.forEach((root) => {
      if (root.dataset.afphReady === 'true') return;
      root.dataset.afphReady = 'true';
      const video = root.querySelector('[data-afph-video]');
      const toggle = root.querySelector('[data-afph-video-toggle]');
      if (!video || !video.dataset.src) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      const saveData = Boolean(connection && connection.saveData);
      const slowConnection = Boolean(connection && /(^|-)2g$/.test(connection.effectiveType || ''));
      const desktop = window.matchMedia('(min-width: 750px)').matches;
      if (!desktop || reducedMotion || saveData || slowConnection) return;

      let loaded = false;
      let playbackTimer;
      const setToggleState = (playing) => {
        if (!toggle) return;
        const pauseIcon = toggle.querySelector('[data-afph-pause-icon]');
        const playIcon = toggle.querySelector('[data-afph-play-icon]');
        if (pauseIcon) pauseIcon.hidden = !playing;
        if (playIcon) playIcon.hidden = playing;
        toggle.setAttribute('aria-label', playing ? 'Pause background video' : 'Play background video');
      };
      const limitPlayback = () => {
        window.clearTimeout(playbackTimer);
        playbackTimer = window.setTimeout(() => {
          video.pause();
          setToggleState(false);
        }, 30000);
      };
      const loadVideo = () => {
        if (loaded) return;
        loaded = true;
        const source = document.createElement('source');
        source.src = video.dataset.src;
        source.type = 'video/mp4';
        video.appendChild(source);
        video.load();
        video.addEventListener('canplay', () => {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.then === 'function') {
            playPromise.then(() => {
              video.classList.add('is-ready');
              if (toggle) toggle.hidden = false;
              setToggleState(true);
              limitPlayback();
            }).catch(() => {});
          }
        }, { once: true });
      };

      const queueVideo = () => {
        window.setTimeout(() => {
          if ('requestIdleCallback' in window) window.requestIdleCallback(loadVideo, { timeout: 4000 });
          else window.setTimeout(loadVideo, 1000);
        }, 4000);
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            observer.disconnect();
            if (document.readyState === 'complete') queueVideo();
            else window.addEventListener('load', queueVideo, { once: true });
          }
        }, { rootMargin: '160px 0px' });
        observer.observe(root.querySelector('.afph-hero'));
      } else if (document.readyState === 'complete') {
        queueVideo();
      } else {
        window.addEventListener('load', queueVideo, { once: true });
      }

      if (toggle) {
        toggle.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(() => {});
            setToggleState(true);
            limitPlayback();
          } else {
            video.pause();
            window.clearTimeout(playbackTimer);
            setToggleState(false);
          }
        });
      }
      video.addEventListener('ended', () => setToggleState(false));
      document.addEventListener('visibilitychange', () => {
        if (document.hidden && !video.paused) {
          video.pause();
          window.clearTimeout(playbackTimer);
          setToggleState(false);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
